<div class="grid-x grid-margin-x">
  <h1 class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8 text-center" [innerHTML]="'moderat.verbrauchsanalyse.start.headline' | translate"></h1>
  <div class="cell small-12 medium-offset-1 medium-3 large-offset-2 large-3">
    <app-advisor-image path="/moc/verbrauchsanalyse-start.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-7 large-5">
    <p [innerHTML]="'moderat.verbrauchsanalyse.start.teaser' | translate"></p>
    <div class="callout lighter-gray show-for-large" [innerHTML]="'moderat.verbrauchsanalyse.start.callout2' | translate"></div>
  </div>
  <div class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8 ">
    <div class="callout lighter-gray hide-for-large" [innerHTML]="'moderat.verbrauchsanalyse.start.callout2' | translate"></div>
    <div class="callout secondary" [innerHTML]="'moderat.verbrauchsanalyse.start.callout1' | translate"></div>
    <app-step-buttons [previousLink]="previousLink" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextSubmit]="false" mediumOffset="0" largeOffset="0" mediumWidthRight="auto" largeWidthRight="auto" nextText="moderat.verbrauchsanalyse.start.next"></app-step-buttons>
  </div>
</div>

